import { jwtDecode } from 'jwt-decode'

type RawDecodedJWT = {
  mid: string
  cid: string
  email: string
  typ: string
  accessType: string
  jti: string
  iss: string
  iat: number
  exp?: number
}

export type DecodedJWT = {
  merchantId: string
  companyId: string
  email: string
  type: string
  accessType: string
  tokenId: string
  issuer: string
  issuedAt: number
  expiresAt?: number
}

const mapToken = (raw: RawDecodedJWT): DecodedJWT => ({
  merchantId: raw.mid,
  companyId: raw.cid,
  email: raw.email,
  type: raw.typ,
  accessType: raw.accessType,
  tokenId: raw.jti,
  issuer: raw.iss,
  issuedAt: raw.iat,
  expiresAt: raw.exp
})

export const useAuthToken = (): DecodedJWT => {
  const url = new URL(window.location.href)
  const authToken = url.searchParams.get('auth')

  if (!authToken) {
    throw new Error('No auth token found')
  }

  const decoded = jwtDecode<RawDecodedJWT>(authToken)

  if (!decoded?.email) {
    throw new Error('Invalid token')
  }

  return mapToken(decoded)
}
